module.exports = __webpack_public_path__ + "img/mizrachi.cd6e47a8.svg";